import React, { memo } from 'react';
import { Button } from 'plume-ui';
import FormattedMessage from '../../utils/components/FormattedMessage';
import { generateCsv } from './helpers';

const CsvTemplate = () => {
  const onCsvClick = () => {
    const csvData = generateCsv(35);
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'template.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
  };

  return (
    <span className="CsvManagementModal Modal__subtitle__wrapper">
      <FormattedMessage id="monitorAdd.uploadCsvModal.subtitlePrefix" />
      <Button onClick={onCsvClick} styleVariant="tertiary">
        <FormattedMessage id="monitorAdd.uploadCsvModal.subtitleButton" />
      </Button>
    </span>
  );
};

export default memo(CsvTemplate);
